import React from 'react';
import { Link } from 'react-router-dom';
import { MapPinIcon, BedIcon, BathIcon, SquareIcon, StarIcon } from 'lucide-react';
import { Listing, formatCurrency, formatArea } from '../utils/mockData';
interface ListingCardProps {
  listing: Listing;
}
const ListingCard: React.FC<ListingCardProps> = ({
  listing
}) => {
  return <Link to={`/listing/${listing.id}`} className="group" data-id="element-228">
      <div className="bg-white rounded-xl shadow-md overflow-hidden card-hover" data-id="element-229">
        <div className="relative h-56 overflow-hidden" data-id="element-230">
          <img src={listing.images[0]} alt={listing.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-231" />
          {listing.featured && <span className="absolute top-3 right-3 bg-accent text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-lg" data-id="element-232">
              Featured
            </span>}
          <span className="absolute bottom-3 left-3 bg-gray-900/80 backdrop-blur-sm text-white text-sm font-semibold px-3 py-1.5 rounded-lg" data-id="element-233">
            {listing.type === 'house' ? 'House' : 'Land'}
          </span>
          <span className={`absolute top-3 left-3 text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-lg ${listing.listingType === 'rent' ? 'bg-green-600' : 'bg-primary'}`} data-id="element-234">
            For {listing.listingType === 'rent' ? 'Rent' : 'Sale'}
          </span>
        </div>
        <div className="p-5" data-id="element-235">
          <div className="flex justify-between items-start mb-3" data-id="element-236">
            <h3 className="text-lg font-semibold text-gray-900 group-hover:text-primary transition-colors line-clamp-1" data-id="element-237">
              {listing.title}
            </h3>
            <p className="text-lg font-bold text-primary whitespace-nowrap ml-2" data-id="element-238">
              {formatCurrency(listing.price)}
              {listing.listingType === 'rent' && <span className="text-xs text-gray-600 font-normal" data-id="element-239">
                  /{listing.rentPeriod === 'monthly' ? 'mo' : 'yr'}
                </span>}
            </p>
          </div>
          <div className="flex items-center mt-2 text-gray-600 mb-3" data-id="element-240">
            <MapPinIcon className="h-4 w-4 mr-1 flex-shrink-0" data-id="element-241" />
            <p className="text-sm truncate" data-id="element-242">{listing.location}</p>
          </div>
          {listing.totalRatings > 0 && <div className="flex items-center mb-3" data-id="element-243">
              <StarIcon className="h-4 w-4 text-yellow-500 fill-yellow-500 mr-1" data-id="element-244" />
              <span className="text-sm font-medium text-gray-900" data-id="element-245">
                {listing.averageRating}
              </span>
              <span className="text-sm text-gray-500 ml-1" data-id="element-246">
                ({listing.totalRatings})
              </span>
            </div>}
          <div className="flex items-center justify-between text-sm text-gray-600 pt-3 border-t border-gray-100" data-id="element-247">
            {listing.type === 'house' ? <>
                <div className="flex items-center" data-id="element-248">
                  <BedIcon className="h-4 w-4 mr-1" data-id="element-249" />
                  <span data-id="element-250">{listing.bedrooms} Beds</span>
                </div>
                <div className="flex items-center" data-id="element-251">
                  <BathIcon className="h-4 w-4 mr-1" data-id="element-252" />
                  <span data-id="element-253">{listing.bathrooms} Baths</span>
                </div>
              </> : null}
            <div className="flex items-center" data-id="element-254">
              <SquareIcon className="h-4 w-4 mr-1" data-id="element-255" />
              <span className="text-xs" data-id="element-256">{formatArea(listing.size)}</span>
            </div>
          </div>
        </div>
      </div>
    </Link>;
};
export default ListingCard;